import ActionAbstract from '../ActionAbstract';

class ToggleJSONEditor extends ActionAbstract {
    static get ID() {
        return 'actions:main:toggleJson';
    }

    run(state) {
        return this.composeState(state, {
            main: {
                jsonEditorOpen: this.toggle,
            },
            jsonEditor: {
                content: this.getParam('content'),
                callback: this.getParam('callback'),
                from: this.getParam('from'),
            }
        });
    }

    toggle(state) {
        let forcedState = this.getParam('open');
        return forcedState !== undefined ? forcedState : !!!state;
    }
}

export default ToggleJSONEditor;